import { useState } from "react";
import { flagSrc } from "../game/countryFlag";
import { countryName } from "../game/place";

/**
 * پرچمِ کشورِ بازیکن روی لبه‌ی آواتار — گرد، با لبه‌ی طلایی. ظرفِ آواتار باید
 * position داشته باشد (کلاسِ `.cflag-host`). کشورِ خالی یا پرچمی که نیامد = هیچ.
 */
export function CountryFlag({ code, hidden }: { code?: string; hidden?: boolean }) {
  const [broken, setBroken] = useState("");
  const src = flagSrc(code);
  if (!src || broken === src) return null;
  const name = countryName(code!) + (hidden ? " — پنهان" : "");
  return (
    <span className={`cflag${hidden ? " off" : ""}`} role="img" aria-label={name} title={name}>
      <img src={src} alt="" decoding="async" onError={() => setBroken(src)} />
    </span>
  );
}
